import { render, staticRenderFns } from "./RestaurantRegular.vue?vue&type=template&id=d35721b2&"
import script from "./RestaurantRegular.vue?vue&type=script&lang=js&"
export * from "./RestaurantRegular.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantRegular.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports